import * as React from "react";
import {useTranslation} from "react-i18next";
import {usePaymentContext} from "./Payment";
import styles from "./CreditCardContainer.module.scss";
import {cardNumber, cvv, expirationDate} from "../../../lib/payments/CreditCardModule";

const CreditCardContainer: React.FC = () => {
  const {creditCardImageRef, isPaymentLoading, frcContainerRef} = usePaymentContext();
  const {t} = useTranslation();

  return (
    <div className={styles.wrapper}>
      {isPaymentLoading && (
        <div className={styles.spinnerContainer}>
          <div className={`swiper-lazy-preloader ${styles.swiperLazyPreloader}`}>{/* loading spinner container */}</div>
        </div>
      )}
      <div className={styles.cardinfoCardNumber}>
        <label htmlFor={cardNumber} className={styles.ccLabel}>
          {t("checkout.cardNumber")}:
        </label>
        <div id={cardNumber} className={styles.cardNumber} />
        <div id="card-image" className={styles.cardImage} ref={creditCardImageRef} />
      </div>
      <label htmlFor={cvv}>{t("checkout.cvv")}:</label>
      <div id={cvv} className={styles.cvv} />
      <label htmlFor={expirationDate}>{t("general.validUntil")}:</label>
      <div id={expirationDate} className={styles.expirationDate} />
      <label>{/* just for spacing purposes */}</label>
      <div className={styles.frcPlacer}>
        <div className="frc-captcha" ref={frcContainerRef} />
        <input type="hidden" name="captcha-response" className="frc-captcha-solution" />
      </div>
      <div id="checkout-message" className={styles.checkoutMessage} />
    </div>
  );
};

export default CreditCardContainer;
